import { useState } from 'react'

import { Pack } from '../../components/pack'
import { STATIC_OBS_URL } from '../../consts'

import './scroll-a.less'

interface ScrollAProps {
  ref?: React.RefObject<HTMLDivElement>
  className?: string
  style?: React.CSSProperties
}
export const ScrollA = (props: ScrollAProps) => {
  const [index, setIndex] = useState(0)
  const [groupIndex, setGroupIndex] = useState(1)
  // console.log('props', props?.ref)
  const clickPic = (index: number) => {
    if (window.innerWidth < 768) {
      return
    }
    setIndex(index)
  }

  const data1 = Array(7)
    .fill(0)
    .map((_, index) => ({
      src: `${STATIC_OBS_URL}/website/home/zhengshu/s${index + 1}.png?6`,
      index,
      key: `s${index + 1}`,
      title: `s${index + 1}`
    }))

  const data2 = Array(8)
    .fill(0)
    .map((_, index) => ({
      src: `${STATIC_OBS_URL}/website/home/zhengshu/h${index}.png?6`,
      index,
      key: `h${index}`,
      title: `h${index}`
    }))

  const curData = groupIndex === 0 ? data1 : data2

  const targetData1 = [
    { ...data1.at(index - 2) },
    { ...data1.at(index - 1) },
    { ...data1.at(index) },
    { ...data1.at((index + 1) % data1.length) },
    { ...data1.at((index + 2) % data1.length) }
  ]

  const targetData2 = [
    { ...data2.at(index - 3) },
    { ...data2.at(index - 2) },
    { ...data2.at(index - 1) },
    { ...data2.at(index) },
    { ...data2.at((index + 1) % data2.length) },
    { ...data2.at((index + 2) % data2.length) },
    { ...data2.at((index + 3) % data2.length) }
  ]
  return (
    <div {...props} className={`scroll-a ${props?.className || ''}`}>
      <Pack className='group-a' if={groupIndex === 0}>
        <div className='box'>
          {targetData1.map(item => {
            const { src, index, key } = item
            return (
              <button
                className='pic'
                key={key}
                onClick={() => {
                  clickPic(index!)
                }}
              >
                <img alt='' src={src} />
              </button>
            )
          })}
        </div>
      </Pack>
      <Pack className='group-b' if={groupIndex === 1}>
        <div className='box'>
          {targetData2.map(item => {
            const { src, index, key } = item
            return (
              <button
                className='pic'
                key={key}
                onClick={() => {
                  clickPic(index!)
                }}
              >
                <img alt='' src={src} />
                {/* <div className='title'>{title}</div> */}
              </button>
            )
          })}
        </div>
      </Pack>

      <div className='buttons'>
        <button
          className='arrow-icon light-left'
          onClick={() => {
            setIndex(index - 1 < 0 ? curData.length - 1 : index - 1)
          }}
        />
        <button
          className='arrow-icon light-right'
          onClick={() => {
            setIndex(index + 1 >= curData.length ? 0 : index + 1)
          }}
        />
        <div className='state'>
          <button
            className={groupIndex === 0 ? 'active' : 'not-active'}
            onClick={() => {
              setIndex(0)
              setGroupIndex(0)
            }}
          />
          <button
            className={groupIndex === 1 ? 'active' : 'not-active'}
            onClick={() => {
              setIndex(0)
              setGroupIndex(1)
            }}
          />
        </div>
      </div>
    </div>
  )
}
